import type { Keyword, OrderBy } from "../types";

const keywordsSorterHof = (orderBy: OrderBy) => {
    const { field, sortDirection } = orderBy;
    if (field === "term") {
        return (a: Keyword, b: Keyword) => {
            if (a.isSeed) {
                return -1;
            }
            if (sortDirection === "desc") {
                return a[field].localeCompare(b[field]);
            }
            return b[field].localeCompare(a[field]);
        };
    }
    return (a: Keyword, b: Keyword) => {
        const aValue = a[field];
        const bValue = b[field];
        if (a.isSeed) {
            return -1;
        }
        if (sortDirection === "asc") {
            if (aValue === undefined) {
                return -1;
            }
            if (bValue === undefined) {
                return 1;
            }
            return aValue - bValue;
        }
        if (aValue === undefined) {
            return 1;
        }
        if (bValue === undefined) {
            return -1;
        }
        return bValue - aValue;
    };
};

export const getSortedKeywords = (keywords: Keyword[], orderBy: OrderBy): Keyword[] => {
    const clonedKeywords = [...keywords];
    const sortedKeywords = clonedKeywords.sort(keywordsSorterHof(orderBy));
    return sortedKeywords;
};
